export default __webpack_public_path__ + "static/media/E23.4fd7f92a.jpg";